import { SvgIcon } from "@mui/material";

const StackOverflowIcon = () => {
	return (
		<SvgIcon
			className="MuiSvgIcon-root MuiSvgIcon-fontSizeLarge css-tzssek-MuiSvgIcon-root"
			focusable="false"
			aria-hidden="true"
			width="512px"
			height="512px"
			viewBox="-40.421 0 512 512"
		>
			<g>
				<path
					fill="#000000"
					points="216.329708 276.187929 216.329708 194.976776 243.28341 194.976776 243.28341 303.14163 0 303.14163 0 194.976776 26.9537015 194.976776 26.9537015 276.187929"
					d="M364.344 465.158L364.344 328.381L409.741 328.381L409.741 510.555L0 510.555L0 328.381L45.395 328.381L45.395 465.158Z"
				/>
				<path
					d="M95.508 315.411L318.359 361.987L327.793 317.18L104.941 270.606L95.508 315.411L95.508 315.411ZM124.986 209.292L331.329 305.389L350.195 264.12L143.852 167.433L124.986 209.292ZM182.172 107.889L357.27 253.509L386.158 218.725L211.06 73.105L182.172 107.889L182.172 107.889ZM295.366 0L258.815 27.119L394.412 209.882L430.964 182.762L295.366 0ZM90.792 419.173L318.359 419.173L318.359 373.778L90.792 373.778L90.792 419.173Z"
					fill="#f48024"
				/>
			</g>
		</SvgIcon>
	);
};

export default StackOverflowIcon;
